<!--
 * @Description: 算命排行榜 -- PC端
 * @Author: xiuwen
 * @Date: 2024-12-25 17:28:10
 * @LastEditors: xiuwen
 * @LastEditTime: 2025-06-23 16:24:54
-->
<template>
	<section class="question-rank">
		<header class="pc-card-header">
			<h2 class="pc-card-title">熱門測試排行榜</h2>
			<!-- <button class="more-btn" type="button" aria-label="查看更多測試" @click="toOnlineCs">
				&gt;
			</button> -->
		</header>
		<div class="pc-card">
			<ul class="pc-card-content">
				<article
					class="pc-card-item"
					v-for="item in rankList"
					:key="item.id"
					@click="jump(item.index_uri)"
				>
					<div class="cover-wrap">
						<img class="cover" :src="item.icon" :alt="item.title" />
					</div>
					<div class="content">
						<div class="title-row">
							<h3 class="title">{{ item.title }}</h3>
							<img
								v-if="item.title.length < 7 && isShowCoupon"
								class="coupon"
								src="../../images/22coupon.png"
								alt=""
							/>
						</div>
						<p class="desc">{{ item.description || "人際考走向，並提供開運錦囊" }}</p>
						<div class="meta">
							<div class="meta-item">
								<img :src="goodIcon" alt="" />
								<span>{{ item.zan || 8567 }}</span>
							</div>
							<div class="meta-item score">
								<div class="stars">
									<img v-for="starIndex in 5" :key="starIndex" :src="starIcon" alt="" />
								</div>
								<span>{{ formatScore(item.score) }}</span>
							</div>
						</div>
					</div>
				</article>
			</ul>
		</div>
	</section>
</template>

<script setup>
import { computed } from "vue";
import { getCalculateRank } from "~/api/api";
import { goLink } from "~/utils/common";
import goodIcon from "../../images/good.png";
import starIcon from "../../images/star.png";

defineProps({
	isShowCoupon: {
		type: Boolean,
		default: false,
	},
});

const { data } = await useLazyAsyncData(
	"onlinecs-question-rank",
	async () => {
		try {
			const res = await getCalculateRank();
			return res.data;
		} catch (error) {
			console.error("加载数据失败:", error);
			return [];
		}
	},
	{
		default: () => [],
	}
);

const rankList = computed(() => data.value.slice(0, 5));

const formatScore = score => {
	const value = Number(score);
	if (!value) {
		return "5.0";
	}
	return (value > 5 ? value / 2 : value).toFixed(1);
};

const jump = url => {
	goLink(url, "calc-ranking-pc");
};

const toOnlineCs = () => {
	navigateTo("/seer/onlinecs");
};
</script>

<style lang="scss" scoped>
.question-rank {
	width: 281px;
	min-height: 642px;
	display: flex;
	flex-direction: column;
	font-family: PingFang SC;

	.pc-card-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 14px;
	}

	.pc-card-title {
		margin: 0;
		font-weight: 500;
		font-size: 20px;
		color: #1f2329;
		line-height: 28px;
	}

	.pc-card {
		flex: 1;
		min-height: 600px;
		padding: 20px 16px 12px;
		box-sizing: border-box;
		background-color: #ffffff;
		border: 1px solid #ececec;
		border-radius: 12px;
	}

	.more-btn {
		padding: 0;
		width: 28px;
		height: 28px;
		border: 1px solid #e9e9e9;
		border-radius: 50%;
		background: #ffffff;
		cursor: pointer;
		font-size: 18px;
		line-height: 26px;
		color: #8b8b8b;
		text-align: center;
	}

	.pc-card-content {
		display: flex;
		flex-direction: column;
		gap: 12px;

		.pc-card-item {
			display: flex;
			align-items: flex-start;
			gap: 10px;
			padding: 10px 0;
			width: 100%;
			cursor: pointer;
			border-bottom: 1px solid #f0f0f0;

			&:last-child {
				border-bottom: none;
			}

			.cover-wrap {
				position: relative;
				width: 60px;
				height: 60px;
				flex-shrink: 0;
			}

			.cover {
				width: 60px;
				height: 60px;
				display: block;
				object-fit: cover;
				border-radius: 8px;
			}

			.content {
				min-width: 0;
				flex: 1;
			}

			.title-row {
				display: flex;
				align-items: center;
				gap: 6px;
				min-width: 0;
			}

			.title {
				margin: 0;
				min-width: 0;
				flex: 1;
				font-family: Helvetica Neue;
				font-weight: 500;
				font-size: 16px;
				color: #2b2f36;
				line-height: 22px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.coupon {
				width: 44px;
				height: 18px;
				flex-shrink: 0;
			}

			.desc {
				margin: 4px 0 0;
				font-size: 13px;
				color: #646a73;
				line-height: 18px;
				display: -webkit-box;
				line-clamp: 2;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				overflow: hidden;
			}

			.meta {
				margin-top: 6px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				gap: 8px;
			}

			.meta-item {
				display: flex;
				align-items: center;
				gap: 4px;
				font-size: 12px;
				color: #646a73;

				img {
					width: 14px;
					height: 14px;
					flex-shrink: 0;
				}
			}

			.score {
				min-width: 0;
			}

			.stars {
				display: flex;
				align-items: center;
				gap: 1px;

				img {
					width: 10px;
					height: 10px;
				}
			}
		}
	}
}
</style>
